import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class VisitCardApi extends Api {
  constructor() {
    super('leasings/visit_cards/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/leasings/visit_cards.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default VisitCardApi;
